var WStationHistoryModal = (function (base) {
  __extends(WStationHistoryModal, base);


  function WStationHistoryModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };


  WStationHistoryModal.prototype.activate = function (wStationId, wStationName) {
    const self = this;

    this.loadContent('api/wstations/{0}/history'.format(wStationId), { wStationName: wStationName })
      .then($modal => {

        datetimepickerInit({ $input: $('#WeatherDate', $modal), withSeconds: true })

        $modal

          //Выбор даты для получения истории МС
          .on('click', '[js=applyFilter]', function () {
            var $control = $('#WeatherDate', $modal);
            $control.attr('readonly', true);

            self.reloadContent('api/wstations/{0}/history?weatherDate='.format(wStationId) + $control.val(), { wStationName: wStationName })
              .then(() => {
                $control.removeAttr('readonly');
                datetimepickerInit({ $input: $('#WeatherDate', $modal), withSeconds: true })
              })
              .catch(() => {
                $control.removeAttr('readonly');
                datetimepickerInit({ $input: $('#WeatherDate', $modal), withSeconds: true })
              });
          });
      });
  };


  return WStationHistoryModal;
}(BaseModal));
